<template>
  <div
    :class="{
      'f-tabs': true,
      'f-tabs-vertical': tabsVertical,
      'is-readonly': readonly,
      'f-tabs-small': !tabsVertical && small,
    }">
    <div
      :class="{
        'f-tabs-header': true,
        'f-tabs-header-extended': extendedHeader,
        'is-open': mobileTabHeaderVisible
      }"
      v-on-clickaway="away">
      <div
        :class="{
          'wrapper': !tabsVertical,
          'f-tabs-header-content': true
        }">
        <ul class="f-tabs-list">
          <li
            v-for="(item, index) in filteredItems"
            :key="index"
            :class="{
              'f-tabs-list-item': true,
              'active': item === activeItem,
              'is-completed': item.completed === true,
              'is-invalid': item.invalid === true,
              'is-not-completed': item.completed === false,
              'is-data-loading': item.completed === 'loading',
              'text-danger' : item.theme === 'danger'
            }"
            @click="triggerTabAction(item)"
            :data-counter="item.counter">
            <span
              v-if="item.title"
              :class="{
                'title': true,
                'hidden-mobile': item.titleMobile
              }">
              {{ item.title }}
            </span>
            <span v-if="item.titleMobile" class="title hidden-desktop-only-inline">{{ item.titleMobile }}</span>
            <span
              v-if="item.showCounter"
              :class="{
                'counter': true,
                'counter-danger': item.messagesNotRead
              }">
              {{ item.counter }}
            </span>
            <span
              v-if="!readonly && tabsVertical && withCompletion"
              class="progress">
            </span>
          </li>
        </ul>
        <div
          v-if="extendedHeader"
          class="tab-header-additional flex flex-align-items-center ml-auto full-height">
          <slot name="tab-header"></slot>
        </div>
      </div>
      <div
        v-if="tabsVertical"
        id="tabsHeaderToggle"
        @click.prevent="handleToggleTabHeader()">
      </div>
    </div>

    <div
      :class="{
        'f-tabs-elements': true,
        'wrapper': !tabsVertical,
        'mt-2': !tabsVertical}">
      <div
        v-for="(item, index) in filteredItems"
        :key="index"
        :class="{
          'f-tabs-elements-item': true,
          'active': item === activeItem
        }">
        <slot :name="'tab-' + index"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'f-tabs',
  mixins: [clickaway],
  props: {
    id: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true
    },
    onToggle: {
      type: Function,
      default: () => false,
    },
    tabsVertical: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    withCompletion: {
      type: Boolean,
      default: true
    },
    defaultActiveItem: {
      type: Number,
      default: 0
    },
    extendedHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filteredItems () {
      return this.items.filter(item => item.visible !== false);
    }
  },
  data() {
    return {
      activeItem: false,
      mobileTabHeaderVisible: false
    };
  },
  mounted() {
    let lastOpenedTab = window.sessionStorage.getItem(this.id);

    if (lastOpenedTab && this.items.indexOf(lastOpenedTab) > -1) {
      this.activeItem = lastOpenedTab;
    } else {
      this.activeItem = this.items[this.defaultActiveItem];
    }
  },
  methods: {
    toggle(newActiveItem) {
      this.activeItem = newActiveItem;
      window.sessionStorage.setItem(this.id, newActiveItem);
      if (this.readonly) {
        let itemIndex = this.items.indexOf(newActiveItem);
        if (itemIndex >= 0) {
          this.$children[itemIndex].$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
        }
      } else {
        this.$el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
      }

      this.onToggle(newActiveItem);
    },
    setItemCompleted (index, isComplete) {
      Vue.set(this.items[index], 'invalid', !isComplete);
      Vue.set(this.items[index], 'completed', isComplete);
      if (!this.tabsVertical) {
        this.$forceUpdate();
      }
    },
    setItemInvalid (index, isInvalid) {
      Vue.set(this.items[index], 'invalid', isInvalid);
      Vue.set(this.items[index], 'completed', !isInvalid);
      if (!this.tabsVertical) {
        this.$forceUpdate();
      }
    },
    triggerTabAction (item) {
      if (item.isAction) {
        item.function(item.param);

        return;
      }

      if (item.triggerAction) {
        item.function(item.param);
      }

      this.handleToggleTabHeader();

      this.toggle(item);
    },
    updateItemCounter (index, count, messagesNotRead = false) {
      Vue.set(this.items[index], 'counter', count);
      Vue.set(this.items[index], 'messagesNotRead', messagesNotRead);
    },
    handleToggleTabHeader () {
      if ((window.matchMedia('screen and (max-width: 840px)')).matches) {
        Vue.set(this, 'mobileTabHeaderVisible', !this.mobileTabHeaderVisible);
      }
    },
    away () {
      if (this.mobileTabHeaderVisible) {
        this.handleToggleTabHeader();
      }
    },
  },
};
</script>
